import { render, staticRenderFns } from "./activityWelcome.html?vue&type=template&id=f785ee6c&external"
import script from "./activityWelcome.vue?vue&type=script&lang=js"
export * from "./activityWelcome.vue?vue&type=script&lang=js"
import style0 from "./activityWelcome.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports